import { render, staticRenderFns } from "./DxfLayersListWrapper.vue?vue&type=template&id=5f5889e7&scoped=true&"
import script from "./DxfLayersListWrapper.vue?vue&type=script&lang=js&"
export * from "./DxfLayersListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DxfLayersListWrapper.vue?vue&type=style&index=0&id=5f5889e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5889e7",
  null
  
)

export default component.exports